import React, { ReactNode, useState } from 'react';
import NavBar from '../components/navbar/NavBar';
import SideBar from '../components/navbar/SideBar';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    if (window.innerWidth < 992) {
      return false;
    }
    return true;
  });

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div>
      <NavBar toggleSidebar={toggleSidebar} />
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          {sidebarOpen && <SideBar />}

          {/* Main Content */}
          <div className="col">
            <div style={{ padding: '1rem' }}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
